import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Collapse } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Text from 'common/components/Text/Text';
import styles from './Postulation.module.scss';
import { RequiredExam, Document } from 'app/types';

interface UploadProps {
  name: string;
  status: string;
  requiredExams: RequiredExam[] | undefined;
  formName: string;
  handleFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text: string;
  mandatory: boolean;
  idPostulation: number | undefined;
  readOnly: boolean;
  files?: Document[];
  formik?: any;
}

interface RequirementProps {
  name: string;
  score: number;
}

const handleText = (name: string, status: string) => {
  if (name === 'Profile') {
    if (status !== 'missing') {
      return 'Filled';
    } else {
      return 'Fill';
    }
  } else if (name === 'Application fee') {
    if (status !== 'missing') {
      return 'Paid';
    } else {
      return 'Pay';
    }
  } else {
    if (status !== 'missing' && status !== 'rejected') {
      return 'Uploaded';
    } else if (status === 'rejected') {
      return 'Upload again';
    } else {
      return 'Upload';
    }
  }
};

const RequirementLabel = ({ name, score }: RequirementProps): React.ReactElement => {
  return <div className={styles.requirementLabel}>{`requirement: ${name} ${score}`}</div>;
};
const UploadCard = ({
  name,
  status,
  requiredExams,
  formName,
  handleFile,
  text,
  mandatory,
  idPostulation,
  readOnly,
  files,
  formik,
}: UploadProps): React.ReactElement => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const fileRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const isMultiple =
    name == 'English Proof' ||
    name == 'Technical test' ||
    name == 'Reference letter' ||
    name == 'Additional documents';
  const showOpenFileDialog = () => {
    fileRef?.current?.click();
  };
  const handleStatusStyle = (status: string) => {
    if (status != 'missing' && status != 'rejected') {
      if (status == 'approved') {
        return styles.finished;
      } else {
        return styles.uploaded;
      }
    }
    return styles.pending;
  };

  const handleStatusName = (status: string) => {
    if (status == 'approved') {
      if (name == 'Profile') {
        return 'finished';
      }
      return 'approved';
    } else if (name == 'Profile') {
      return 'unfinished';
    }
    return status;
  };

  const uploadedFiles = (): Document[] | File[] | undefined => {
    if (formik === undefined) {
      return [];
    }
    if (files && formik.values[formName]) {
      return files.concat(formik.values[formName]);
    }
    if (files && !formik.values[formName]) {
      return files;
    }
    if (formik.values[formName]) {
      return formik.values[formName];
    }
    return [];
  };

  uploadedFiles();
  return (
    <>
      {isMobile ? (
        <div className={styles.uploadCard}>
          <Button
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            className={styles.collapseButton}
            aria-controls={name}
          >
            <div className={styles.wrap}>
              <i
                className={`bi bi-check-circle ${
                  status != 'missing' && status != 'rejected' ? styles.active : ''
                }`}
              ></i>
              <Text size={14} weight={500} color="primary">
                {name}
              </Text>
              <input
                type="file"
                style={{ display: 'none' }}
                accept={`.pdf, .jpg, .png${
                  ['Personal statement', 'Additional documents'].includes(name) ? ', .docx' : ''
                }`}
                name={formName}
                onChange={handleFile}
                ref={fileRef}
              />
            </div>
          </Button>
          {!readOnly && (
            <button
              className={`${styles.button} btn ${
                status != 'missing' && status != 'rejected' ? styles.active : ''
              }`}
              onClick={
                name == 'Profile'
                  ? () => navigate('/home/personal_information')
                  : showOpenFileDialog
              }
              type="button"
            >
              <Text size={status === 'rejected' ? 10 : 12} weight={600}>
                {handleText(name, status)}
              </Text>
            </button>
          )}
          <Collapse in={open}>
            <div id={name} className={styles.collapseBody}>
              {text}
            </div>
          </Collapse>
        </div>
      ) : (
        <div className={styles.uploadCard}>
          <div className={styles.header}>
            <div className={styles.wrapper}>
              {readOnly && (
                <i className={`bi bi-check-circle ${status != 'missing' ? styles.active : ''}`}></i>
              )}
              <Text
                size={16}
                weight={500}
                color="primary"
                inlineStyle={{ width: '255px', display: 'flex', gap: '5px', alignItems: 'center' }}
              >
                {name}
                {!mandatory && !readOnly && (
                  <Text size={14} weight={500} color="secondary" inlineStyle={{ width: 'auto' }}>
                    (optional)
                  </Text>
                )}
              </Text>
              {!readOnly && (
                <div className={`${styles.status} ${handleStatusStyle(status)}`}>
                  {handleStatusName(status)}
                </div>
              )}
              <div className={styles.requirements}>
                {requiredExams?.map((requiredExam: RequiredExam) => (
                  <RequirementLabel
                    name={requiredExam.name}
                    score={requiredExam.min_score}
                    key={requiredExam.id}
                  />
                ))}
              </div>
            </div>
            <div className={styles.secondWrap}>
              {!readOnly && (
                <button
                  className={`${styles.button} ${
                    status != 'missing' && status != 'rejected' ? styles.active : ''
                  } btn`}
                  onClick={
                    name == 'Profile'
                      ? () => navigate('/home/personal_information', { state: idPostulation })
                      : showOpenFileDialog
                  }
                  type="button"
                >
                  <Text size={16} weight={700}>
                    {handleText(name, status)}
                  </Text>
                </button>
              )}
              <Button
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className={styles.collapseButton}
                aria-controls={name}
                type="button"
              >
                <div>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    accept={`.pdf, .jpg, .png${
                      ['Personal statement', 'Additional documents'].includes(name) ? ', .docx' : ''
                    }`}
                    name={formName}
                    onChange={handleFile}
                    ref={fileRef}
                    multiple={isMultiple}
                  />
                  <i className={open ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}></i>
                </div>
              </Button>
            </div>
          </div>
          <div>
            <Collapse in={open}>
              <div id={name} className={styles.collapseBody}>
                {name == 'Technical test' && mandatory ? (
                  'Please upload your scores English test scores in pdf format'
                ) : name == 'CV' ? (
                  <div className={styles.cvText}>
                    <Text>
                      The CV is an important component of the application in which you can showcase
                      your accomplishments during your education and through your work experience.
                      For more information about how to write a good CV please visit our tutorial{' '}
                      <span
                        className={styles.loginLink}
                        onClick={() =>
                          window.open(
                            'https://blog.unifyapply.com/how-to-create-the-perfect-cv-for-business-school/'
                          )
                        }
                      >
                        here
                      </span>
                      .
                    </Text>
                  </div>
                ) : (
                  text
                )}
                {name !== 'Profile' &&
                  uploadedFiles()?.map((file: Document | File, index: number) => (
                    <div className={styles.fileContainer} key={file.name}>
                      <i className="bi bi-file-earmark"></i>
                      <Text size={14} weight={500}>
                        {`${file.name}_${index + 1}`}
                      </Text>
                      {'url' in file ? (
                        <i className="bi bi-download" onClick={() => window.open(file.url)}></i>
                      ) : (
                        <i
                          className="bi bi-download"
                          onClick={() => {
                            if (file instanceof File) {
                              window.open(URL.createObjectURL(file));
                            }
                          }}
                        ></i>
                      )}
                    </div>
                  ))}
              </div>
            </Collapse>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadCard;
